import { type ActionType, createAction } from 'typesafe-actions';
import { createRoutine } from '../common/utils/new-routines';
import type { StatusUpdate } from './types';

export type GetStatusUpdateListPayload = {
  contentId: string;
  shapeName: string;
};

export type CreateStatusUpdatePayload = {
  contentId: string;
  shapeName: string;
  timestamp: string;
  status: string;
};

export type CancelStatusUpdatePayload = {
  contentId: string;
  shapeName: string;
  timestamp: string;
};

export const getStatusUpdateListRoutine = createRoutine('schedule/GET_STATUS_UPDATE_LIST')<
  undefined,
  GetStatusUpdateListPayload,
  undefined,
  StatusUpdate[],
  string,
  undefined
>();
export type GetStatusUpdateListType = ActionType<typeof getStatusUpdateListRoutine>;

export const scheduleStatusUpdateRoutine = createRoutine('schedule/SCHEDULE_STATUS_UPDATE')<
  undefined,
  CreateStatusUpdatePayload,
  undefined,
  StatusUpdate,
  string,
  undefined
>();
export type ScheduleStatusUpdateType = ActionType<typeof scheduleStatusUpdateRoutine>;

export const cancelStatusUpdateRoutine = createRoutine('schedule/CANCEL_STATUS_UPDATE')<
  undefined,
  CancelStatusUpdatePayload,
  undefined,
  boolean,
  string,
  undefined
>();
export type CancelStatusUpdateType = ActionType<typeof cancelStatusUpdateRoutine>;

export const CLEAR_STATUS_UPDATE_LIST = 'schedule/CLEAR_STATUS_UPDATE_LIST';
export const clearStatusUpdateList = createAction(CLEAR_STATUS_UPDATE_LIST)();
export type ClearStatusUpdateListType = ActionType<typeof clearStatusUpdateList>;

export type SetSchedulePayload = {
  contentId: string;
  shapeName: string;
  timestamp: string | null;
  status: string;
};

export const SET_SCHEDULE = 'schedule/SET_SCHEDULE';
export const setSchedule = createAction(SET_SCHEDULE)<SetSchedulePayload>();
export type SetScheduleType = ActionType<typeof setSchedule>;
